import React from "react"
import { twMerge } from "tailwind-merge"

import { Button } from "./Buttons"

const EventTypeCard = ({ eventType, onEditClick, className, showEditButton = true, editButtonText = "Edit" }) => {
  // Get the label for the duration unit: min, hour, day. Pluralize if needed.
  const durationUnitLabel = eventType.durationUnit === "minute" ? "min" : eventType.durationUnit
  const durationLabel =
    eventType.duration === 1
      ? `${eventType.duration} ${durationUnitLabel}`
      : `${eventType.duration} ${durationUnitLabel}s`

  return (
    <div
      className={twMerge(
        "relative flex w-full items-start rounded-lg border border-gray-light bg-white p-4",
        className
      )}>
      <div className="flex w-full items-start justify-between gap-4">
        {/* Event Image */}
        <div className="h-16 w-16 shrink-0">
          {eventType?.photoUrl ? (
            <img src={eventType.photoUrl} alt={eventType.name} className="h-full w-full rounded-lg object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center rounded-lg bg-gray-light">
              <span className="text-sm text-gray-dark">No Image</span>
            </div>
          )}
        </div>

        {/* Event Details */}
        <div className="flex grow flex-col gap-1">
          <div className={showEditButton ? "pr-10" : ""}>
            <h3 className="font-bold">{eventType?.name || "Event Type"}</h3>
          </div>
          <div className="flex flex-col text-sm text-gray-dark">
            <div>
              {durationLabel} • {eventType?.amountCents > 0 ? `$${eventType.amountCents / 100}` : "Free"}
            </div>
            <div>
              {eventType?.capacity === null ? "Unlimited" : eventType?.capacity || "30"} Capacity •{" "}
              {eventType?.kind === "in_person" ? eventType?.location || "In-person" : "Virtual"}
            </div>
          </div>
        </div>

        {/* Edit Button */}
        {showEditButton && onEditClick && (
          <Button type="link" className="font-bold text-teal" onClick={onEditClick}>
            {editButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default EventTypeCard
